// extracted by mini-css-extract-plugin
export default {"publicCheckbox":"RegistryVisibilityForm-styles__publicCheckbox__D_UVH"};